export default __webpack_public_path__ + "46f130a0bf0e67be61630875891b8c8a.wasm";